import React, { useEffect, useState } from "react";
import sponsorBannerImage from '../../assets/sponsor-banner.png';
import ButtonComponent from "../../components/ButtonComponent/ButtonComponent";
import CheckboxComponent from "../../components/CheckboxComponent/CheckboxComponent";
import DropdownComponent from "../../components/DropdownComponent/DropdownComponent";
import InputComponent from "../../components/InputComponent/InputComponent";
import LoaderComponent from "../../components/LoaderComponent/LoaderComponent";
import NotificationComponent from "../../components/NotificationComponent/NotificationComponent";
import { addSponsorMaster, getEventList } from "../../services/apiController";

const SponsorWithUs = () => {
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        selectedEventId: '', name: '', companyname: '', email: '', contectno: '',
        poccontactname: '', poccontactdesignation: '', pocemail: '', pocmobileno: '',
        businesscategory: '', sponsorshipcategory: '', approximatebudget: ''
    });
    const [errors, setErrors] = useState({}); // To store validation errors
    const [sameAsAbove, setSameAsAbove] = useState(false);

    const [eventsData, setEventsData] = useState([]);

    // State to manage snackbar visibility and messages
    const [snackbarStates, setSnackbarStates] = useState({ isSnackbarOpen: false, snackbarMessage: '' });
    const handleCloseSnackbar = () => {
        setSnackbarStates({ isSnackbarOpen: false, snackbarMessage: '', snackbarSeverity: '' });
    };

    useEffect(() => {
        wsGetEventData();
    }, []);

    const wsGetEventData = () => {
        setLoading(true);
        getEventList().then((response) => {

            const formattedData = (response.tickets || []).map(item => ({
                id: item.TicketMasterId,
                value: item.EventName
            }));

            setEventsData(formattedData);

            selectDefaultEvent(response);

            setLoading(false);
        }).catch((error) => {
            setLoading(false);
        });
    };

    const selectDefaultEvent = (ticketsData) => {
        ticketsData.tickets.length === 1 && setFormData((prev) => ({ ...prev, selectedEventId: ticketsData.tickets[0]?.TicketMasterId }));
    }

    // Your existing handlers (handleChange, increment, decrement, etc.)
    const handleChange = (e, type, maxLength) => {
        const { name, value } = e.target;
        if (type === 'number') {
            // Allow only digits (0-9), and optionally + at the start
            if (/^\+?\d*$/.test(value)) {
                // Optional: Limit length (e.g., 15 digits max)
                if (value.length <= maxLength) { // + sign + 15 digits
                    setFormData((prev) => ({ ...prev, [name]: value }));
                    setErrors((prev) => ({ ...prev, [name]: '' }));
                }
            }
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));

            // Clear error when user starts typing
            if (errors[name]) {
                setErrors((prev) => ({ ...prev, [name]: '' }));
            }
        }
    };

    const handleSameAsAbove = (e) => {
        const checked = e.target.checked;
        setSameAsAbove(checked);

        if (checked) {
            setFormData(prev => ({ ...prev, poccontactname: prev.name, pocemail: prev.email, pocmobileno: prev.contectno }));
            setErrors((prev) => ({ ...prev, poccontactname: '', pocemail: '', pocmobileno: '' }));
        }
        // else {
        //     setFormData(prev => ({ ...prev, poccontactname: '', pocemail: '', pocmobileno: '' }));
        // }
    };

    // Email validation function
    const validateEmail = (email) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email) {
            return 'Email is required';
        }
        if (!emailRegex.test(email)) {
            return 'Please enter a valid email address';
        }
        return '';
    };

    // Form submission with validation
    const handleSubmit = (e) => {
        e?.preventDefault(); // Prevent default if used in <form>

        // Validate other required fields (optional)
        const newErrors = {};

        if (formData.selectedEventId == "") newErrors.selectedEventId = 'Event is required';
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        if (!formData.companyname.trim()) newErrors.companyname = 'Company Name is required';
        if (!formData.email.trim()) newErrors.email = 'Email is required';
        if (!formData.contectno.trim()) newErrors.contectno = 'Contect Number is required';
        if (!formData.poccontactname.trim()) newErrors.poccontactname = 'POC Contact Name is required';
        if (!formData.poccontactdesignation.trim()) newErrors.poccontactdesignation = 'POC Contact Designation is required';
        if (!formData.pocemail.trim()) newErrors.pocemail = 'POC Email is required';
        if (!formData.pocmobileno.trim()) newErrors.pocmobileno = 'POC Mobiel Number is required';
        // if (!formData.businesscategory.trim()) newErrors.businesscategory = 'Business Category is required';
        // if (!formData.sponsorshipcategory.trim()) newErrors.sponsorshipcategory = 'Sponsorship Category is required';
        if (!formData.approximatebudget.trim()) newErrors.approximatebudget = 'Approximate Budget is required';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Validate email
        const emailError = validateEmail(formData.email);
        if (emailError) {
            setErrors({ email: emailError });
            return; // Stop submission
        }

        const pocemailError = validateEmail(formData.pocemail);
        if (pocemailError) {
            setErrors({ pocemail: pocemailError });
            return; // Stop submission
        }

        // Clear any previous errors
        setErrors({});

        // Success: Proceed with submission 
        wsAddSponsorWithUs(formData)
    };

    const wsAddSponsorWithUs = (formData) => {
        setLoading(true);
        const apiParameter = {
            "EventMasterId": formData.selectedEventId,
            "SponsorName": formData.name,
            "SponsorCompanyName": formData.companyname,
            "SponsorContactNo": formData.contectno,
            "SponsorEmail": formData.email,
            "ContactPersonName": formData.poccontactname,
            "ContactPersonDesignation": formData.poccontactdesignation,
            "ContactPersonEmail": formData.pocemail,
            "ContactPersonMobile": formData.pocmobileno,
            "BusinessCategory": formData.businesscategory,
            "ApproximateBudget": formData.approximatebudget,
            "InterestedSponsorCategory": formData.sponsorshipcategory,
            "EntryUserMasterId": 1
        }

        addSponsorMaster(apiParameter)
            .then((response) => {
                if (response.status == 1) {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'success' });
                    setFormData({
                        name: '', companyname: '', email: '', contectno: '',
                        poccontactname: '', poccontactdesignation: '', pocemail: '', pocmobileno: '',
                        businesscategory: '', sponsorshipcategory: '', approximatebudget: ''
                    });
                    setSameAsAbove(false);
                } else {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'error' });
                }
                setLoading(false);
            }).catch((error) => {
                setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Something went wrong, Please try again", snackbarSeverity: 'error' });
                setLoading(false);
            });
    }

    return (
        loading ? <LoaderComponent />
            : <React.Fragment>
                <NotificationComponent isOpen={snackbarStates.isSnackbarOpen} message={snackbarStates.snackbarMessage} onClose={handleCloseSnackbar} severity={snackbarStates.snackbarSeverity} />

                <img src={sponsorBannerImage} style={{ width: '100%' }} />

                <div className="booking-container">
                    {/* Card for Ticket Form */}
                    <div className="booking-sub-container">
                        <h2 className="heading">Sponsor With Us</h2>

                        {/* Form Inputs (Text Fields with Underline and Two Columns) */}
                        <div className="form-container">

                            <DropdownComponent name="selectedEventId" placeholder="Select Event*" value={formData.selectedEventId} onChange={handleChange} error={errors.selectedEventId} options={eventsData} />

                            <div className="form-grid" style={{ marginTop: '30px' }}>
                                <InputComponent name="name" placeholder="Full Name*" value={formData.name} onChange={handleChange} error={errors.name} />
                                <InputComponent name="companyname" placeholder="Company Name*" value={formData.companyname} onChange={handleChange} error={errors.companyname} />
                                <InputComponent name="email" type="email" placeholder="Email ID*" value={formData.email} onChange={handleChange} error={errors.email} />
                                <InputComponent name="contectno" placeholder="Contect Number*" value={formData.contectno} onChange={(e) => handleChange(e, 'number', 10)} error={errors.contectno} />
                            </div>

                            <div className="poc-details">
                                <div className="poc-header">
                                    <label className="event-radio-card-label">POC contact person details</label>
                                    <div className="poc-checkbox">
                                        <CheckboxComponent label="Same as above" checked={sameAsAbove} onChange={handleSameAsAbove} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-grid">
                                <InputComponent name="poccontactname" placeholder="POC Contact Name*" value={formData.poccontactname} onChange={handleChange} error={errors.poccontactname} />
                                <InputComponent name="poccontactdesignation" placeholder="POC Contact Designation*" value={formData.poccontactdesignation} onChange={handleChange} error={errors.poccontactdesignation} />
                                <InputComponent name="pocemail" type="email" placeholder="POC Email ID*" value={formData.pocemail} onChange={handleChange} error={errors.pocemail} />
                                <InputComponent name="pocmobileno" placeholder="POC Mobile Number*" value={formData.pocmobileno} onChange={(e) => handleChange(e, 'number', 10)} error={errors.pocmobileno} />
                            </div>

                            {/* <div className="sub-heading">Indicate The Kind Of Food You Want To Sale At Akadeet.</div> */}
                            <div style={{ marginTop: '20px' }}>
                                <InputComponent multiline name="businesscategory" placeholder="Business Category" value={formData.businesscategory} onChange={handleChange} error={errors.businesscategory} />
                                <InputComponent multiline name="sponsorshipcategory" placeholder="Interested Sponsorship Category" value={formData.sponsorshipcategory} onChange={handleChange} error={errors.sponsorshipcategory} />
                                <InputComponent name="approximatebudget" placeholder="Approximate Budget*" value={formData.approximatebudget} onChange={(e) => handleChange(e, 'number', 7)} error={errors.approximatebudget} />
                            </div>

                            {/* <InputComponent name="city" placeholder="Which City Are You Located In ?" value={formData.city} onChange={handleChange} error={errors.city} /> */}
                        </div>

                        {/* Submit Button */}
                        <div style={{ textAlign: 'end', marginBottom: '2%' }}>
                            <ButtonComponent disabled={loading} onClick={handleSubmit}>Send Details</ButtonComponent>
                        </div>
                    </div>
                </div>


            </React.Fragment>
    );
};

export default SponsorWithUs;
